import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { firestore } from "../../firebase.js"
import Ratings from 'react-ratings-declarative';

import * as commentFormStyles from './commentForm.module.scss'

const CommentBox = styled.div`
  
`

const CommentForm = ({ parentId, blogId, path }) => {
  const [name, setName] = useState("")
  const [content, setContent] = useState("")
  const [email, setEmail] = useState("")
  const [rating, setRating] = useState(0)
  const [err, setErr] = useState("")
  const [status, setStatus] = useState("")

  const handleCommentSubmission = async e => {
    e.preventDefault()
    let comment = {
      blogId: blogId,
      name: name,
      email: email,
      content: content,
      rating: rating,
      pId: parentId || null,
      time: new Date(),
      path: path,
    }
    setName("")
    setContent("")
    setEmail("")
    setRating(0)
    firestore
      .collection(`comments`)
      .add(comment)
      .catch(err => {
        setErr(`Error adding comment: ${err}`)
    })
    if (err === "") {
      setStatus("Comment posted!")
    }
  }

  return (
    <CommentBox >
      <form onSubmit={e => handleCommentSubmission(e)} className={commentFormStyles.form}>
      {parentId === undefined ? 
        <div>
          <span className={commentFormStyles.ratingText}>Your rating: </span>
          <Ratings
            rating={rating}
            widgetRatedColors="rgb(255,102,0)"
            widgetHoverColors="rgb(255, 204, 0)"
            changeRating={setRating}
            widgetDimensions="30px"
            widgetSpacings="3px"
          >
            <Ratings.Widget />
            <Ratings.Widget />
            <Ratings.Widget />
            <Ratings.Widget />
            <Ratings.Widget />
          </Ratings>
          </div>
         : <div></div>}
         <div className={commentFormStyles.name}>
          <label htmlFor="name" className={commentFormStyles.label}>
            Name
            <input
              type="text"
              id="name"
              value={name}
              onChange={e => {setName(e.target.value);
              setStatus("")}}
              required
            />
          </label>
        </div>
        <div className={commentFormStyles.email}>
          <label htmlFor="email" className={commentFormStyles.label}>
            Email (not displayed)
            <input
              type="email"
              id="email"
              value={email}
              onChange={e => {setEmail(e.target.value);
                setStatus("")}}
              required
            />
          </label>
        </div>
        <div className={commentFormStyles.comment}>
          <label htmlFor="comment" className={commentFormStyles.label}>
            Comment
            <textarea
              id="comment"
              onChange={e => {setContent(e.target.value);
                setStatus("")}}
              value={content}
              name="comment"
              required
              cols="45"
              rows="8"
            ></textarea>
          </label>
        </div>
        <div className={commentFormStyles.error}>{err}</div>
        <div className={commentFormStyles.status}>{status}</div>
        <button className={`btn-color btn ${commentFormStyles.submit}`} type="submit">
          Submit
        </button>
      </form>
    </CommentBox>
  )
}

CommentForm.propTypes = {
  parentId: PropTypes.string,
  blogId: PropTypes.string.isRequired,
  path: PropTypes.string,
}

export default CommentForm